import { Icon } from '@/components/Icon';
import { Viewer3D } from '@/components/Viewer3D';

import * as S from './Viewer3DModal.styles';

export interface Viewer3DModalProps {
  isOpen: boolean;
  modelName: string;
  onClose: () => void;
}

const ASSET_PATH = process.env.NEXT_PUBLIC_3D_ASSETS_URL || '/3d-assets/';

const Viewer3DModal = ({ isOpen, modelName, onClose }: Viewer3DModalProps) => (
  <S.StyledModal
    data-test-id='3DViewerModal'
    gutters={false}
    height='100vh'
    isOpen={isOpen}
    maxWidth='xl'
    onClose={onClose}
    overflowHidden={true}
    width='100vw'
  >
    <S.Content>
      <S.CloseButton aria-label='Close 3D viewer' onClick={onClose}>
        <Icon name='close' />
      </S.CloseButton>
      <Viewer3D assetPath={ASSET_PATH} modelName={modelName} />
    </S.Content>
  </S.StyledModal>
);

export default Viewer3DModal;
